/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum RosState {
	Stop = 0,
	Manual = 1,
	Auto = 2,
	Calibration = 3,
}

/** @format int32 */
export enum RosMissionStatus {
	NoMissionLoaded = 0,
	MissionLoaded = 1,
	MissionRunnable = 2,
	MissionRunning = 3,
	MissionCompleted = 4,
}

/** @format int32 */
export enum MissionType {
	Tillage = 0,
	Harvest = 1,
}

/** @format int32 */
export enum MissionDeployStatus {
	None = 0,
	Pending = 1,
	Deployed = 2,
	Started = 3,
}

export enum LeaderFollowerMachineType {
	Harvester = "harvester",
	Cart = "cart",
}

/** @format int32 */
export enum LayerType {
	SkipDouble = 0,
	Population = 1,
	Coverage = 2,
	Generic = 3,
	Path = 4,
	DrivenPath = 5,
	EstimatedCoverage = 6,
	Obstacle = 7,
	PlannedPath = 8,
	FieldBoundary = 9,
	StagingArea = 10,
	TravelCorridor = 11,
	ReducedSpeedAreas = 12,
	WorkArea = 13,
	UserCoverage = 14,
	Yield = 15,
}

/** @format int32 */
export enum ImplementType {
	Tiller = 0,
	CombineHeader = 1,
	Spreader = 2,
	GrainCart = 3,
}

/** @format int32 */
export enum HttpStatusCode {
	Continue = 100,
	SwitchingProtocols = 101,
	Processing = 102,
	EarlyHints = 103,
	OK = 200,
	Created = 201,
	Accepted = 202,
	NonAuthoritativeInformation = 203,
	NoContent = 204,
	ResetContent = 205,
	PartialContent = 206,
	MultiStatus = 207,
	AlreadyReported = 208,
	IMUsed = 226,
	Ambiguous = 300,
	Moved = 301,
	Redirect = 302,
	RedirectMethod = 303,
	NotModified = 304,
	UseProxy = 305,
	Unused = 306,
	RedirectKeepVerb = 307,
	PermanentRedirect = 308,
	BadRequest = 400,
	Unauthorized = 401,
	PaymentRequired = 402,
	Forbidden = 403,
	NotFound = 404,
	MethodNotAllowed = 405,
	NotAcceptable = 406,
	ProxyAuthenticationRequired = 407,
	RequestTimeout = 408,
	Conflict = 409,
	Gone = 410,
	LengthRequired = 411,
	PreconditionFailed = 412,
	RequestEntityTooLarge = 413,
	RequestUriTooLong = 414,
	UnsupportedMediaType = 415,
	RequestedRangeNotSatisfiable = 416,
	ExpectationFailed = 417,
	MisdirectedRequest = 421,
	UnprocessableContent = 422,
	Locked = 423,
	FailedDependency = 424,
	UpgradeRequired = 426,
	PreconditionRequired = 428,
	TooManyRequests = 429,
	RequestHeaderFieldsTooLarge = 431,
	UnavailableForLegalReasons = 451,
	InternalServerError = 500,
	NotImplemented = 501,
	BadGateway = 502,
	ServiceUnavailable = 503,
	GatewayTimeout = 504,
	HttpVersionNotSupported = 505,
	VariantAlsoNegotiates = 506,
	InsufficientStorage = 507,
	LoopDetected = 508,
	NotExtended = 510,
	NetworkAuthenticationRequired = 511,
}

/** @format int32 */
export enum GnssMethod {
	NoGps = 0,
	GnssFix = 1,
	DgnssFix = 2,
	PreciseGnss = 3,
	RtkFixedInteger = 4,
	RtkFloat = 5,
	EstimatedMode = 6,
	ManualInput = 7,
	SimulateMode = 8,
	Error = 9,
	Undefined = 10,
}

/** @format int32 */
export enum GPSFixStatus {
	SinglePointPositioning = 0,
	SatelliteBasedAugmentationSystem = 1,
	DifferentialGPS = 2,
	RTKFloat = 3,
	RTKFix = 4,
	NoFix = -1,
}

/** @format int32 */
export enum FieldMode {
	Adjacent = 0,
	InLine = 1,
}

/** @format int32 */
export enum DeployedSinglePathMissionCloudState {
	LaunchRequest = 0,
	Pending = 1,
	DeployedRunning = 2,
	Canceled = 3,
	ConfirmedCompleted = 4,
}

/** @format int32 */
export enum DeployedLeaderFollowerMissionState {
	LaunchRequest = 0,
	Pending = 1,
	DeployedRunning = 2,
	Canceled = 3,
	Completed = 4,
}

/** @format int32 */
export enum CoreChecksumAlgorithm {
	NONE = 0,
	CRC32C = 1,
	CRC32 = 2,
	SHA256 = 3,
	SHA1 = 4,
	CRC64NVME = 5,
	MD5 = 6,
	SHA512 = 7,
	XXHASH128 = 8,
	XXHASH3 = 9,
	XXHASH64 = 10,
}

/** @format int32 */
export enum ConnectorType {
	TractorDrawBar = 0,
	ThreePointHitchMounted = 1,
}

/** @format int32 */
export enum ChecksumValidationStatus {
	NOT_VALIDATED = 0,
	PENDING_RESPONSE_READ = 1,
	SUCCESSFUL = 2,
	INVALID = 3,
}

/** @format int32 */
export enum BoundaryType {
	Field = 1,
	Coverage = 2,
	WorkArea = 3,
	SpeedZone = 4,
	NoCoverageZone = 5,
	NoGoZone = 6,
	InnerField = 7,
	Road = 8,
	Geofence = 9,
}

/** @format int32 */
export enum AdjacentMode {
	SkipOne = 0,
	SkipTwo = 1,
}

export interface Account {
	AccountId?: string | null;
	Name?: string | null;
	Description?: string | null;
	Deleted: boolean;
	IsEngineeringOrganization: boolean;
}

export interface AccountDeleteResponse {
	Deleted: boolean;
	AttachedUsers?: UserWithGroups[] | null;
}

export interface ActionIndex {
	Action?: string | null;
	/** @format int32 */
	Index: number;
}

export interface AdminCreateUserResponse {
	ResponseMetadata?: ResponseMetadata;
	/** @format int64 */
	ContentLength: number;
	HttpStatusCode: HttpStatusCode;
	User?: UserType;
}

export interface AdminDeleteUserResponse {
	ResponseMetadata?: ResponseMetadata;
	/** @format int64 */
	ContentLength: number;
	HttpStatusCode: HttpStatusCode;
}

export interface AdminDisableUserResponse {
	ResponseMetadata?: ResponseMetadata;
	/** @format int64 */
	ContentLength: number;
	HttpStatusCode: HttpStatusCode;
}

export interface AdminEnableUserResponse {
	ResponseMetadata?: ResponseMetadata;
	/** @format int64 */
	ContentLength: number;
	HttpStatusCode: HttpStatusCode;
}

export interface AdminGetUserResponse {
	ResponseMetadata?: ResponseMetadata;
	/** @format int64 */
	ContentLength: number;
	HttpStatusCode: HttpStatusCode;
	Enabled?: boolean | null;
	MFAOptions?: MFAOptionType[] | null;
	PreferredMfaSetting?: string | null;
	UserAttributes?: AttributeType[] | null;
	/** @format date-time */
	UserCreateDate?: string | null;
	/** @format date-time */
	UserLastModifiedDate?: string | null;
	UserMFASettingList?: string[] | null;
	Username?: string | null;
	UserStatus?: UserStatusType;
}

export interface AlarmModel {
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	OrganizationId: string;
	/** @format uuid */
	MissionId: string;
	alarm_reference?: string | null;
	/** @format int64 */
	alarm_id: number;
	active_uuid?: string | null;
	/** @format int32 */
	severity: number;
	active: boolean;
	acknowledged: boolean;
	overridden: boolean;
	/** @format double */
	alarm_time: number;
	description?: string | null;
	action?: string | null;
	parameters?: string | null;
}

export interface AmazonWebServiceResponse {
	ResponseMetadata?: ResponseMetadata;
	/** @format int64 */
	ContentLength: number;
	HttpStatusCode: HttpStatusCode;
}

export interface AreaPolygon {
	DrawPoints?: GpsLocation[] | null;
	OuterPoints?: GpsLocation[] | null;
	InnerPoints?: GpsLocation[] | null;
	StartPoint: GpsLocation;
	LatestLeftPoint: GpsLocation;
	LatestRightPoint: GpsLocation;
	/** @format float */
	PixelLayerData: number;
	IsEstimated: boolean;
	/** @format uuid */
	PolygonId: string;
	/** @format double */
	readonly MaxLatitude: number;
	/** @format double */
	readonly MaxLongitude: number;
	/** @format double */
	readonly MinLatitude: number;
	/** @format double */
	readonly MinLongitude: number;
}

export interface AttributeType {
	Name?: string | null;
	Value?: string | null;
}

export interface BinDto {
	/** @format int32 */
	readonly ElementIndex: number;
	/** @format int32 */
	readonly ParentIndex: number;
	/** @format int32 */
	PhysicalSetPointTimeLatencyMilliseconds: number;
	ActualCulturalPractice?: string | null;
}

export interface BoomDto {
	/** @format int32 */
	readonly ElementIndex: number;
	/** @format int32 */
	readonly ParentIndex: number;
	/** @format int32 */
	SectionControlTurnOnMilliseconds: number;
	/** @format int32 */
	SectionControlTurnOffMilliseconds: number;
	/** @format double */
	SetPointRate: number;
	/** @format double */
	SectionControlOverlapThreshold: number;
	LeaveImplementDownOnTurns: boolean;
}

export interface Boundary {
	/** @format uuid */
	id: string;
	type: BoundaryType;
	/** GeoJSON Geometry */
	geometry: Geometry;
	/** @format date-time */
	created: string;
	/** @format date-time */
	updated: string;
	/** @format double */
	SpeedLimit?: number | null;
	/** @maxLength 255 */
	name?: string | null;
}

export interface BoundarySummary {
	/** @format uuid */
	id: string;
	type: BoundaryType;
	/** @format date-time */
	created: string;
	/** @format date-time */
	updated: string;
	/** @format double */
	areaM2: number;
	/** GeoJSON Polygon */
	bbox: Polygon;
	/** @format double */
	SpeedLimit?: number | null;
	/** @maxLength 255 */
	name?: string | null;
}

export interface BoundaryUpdate {
	/** @format uuid */
	id: string;
	type: BoundaryType;
	/** GeoJSON Geometry */
	geometry: Geometry;
	/** @format double */
	SpeedLimit?: number | null;
	/** @maxLength 255 */
	name?: string | null;
}

export interface ClothoidPath {
	Metadata?: PathMetadata;
	Origin?: PathOrigin;
	Segments?: ClothoidSegment[] | null;
	Type?: string | null;
}

export interface ClothoidSegment {
	/** @format double */
	CurvatureRate: number;
	/** @format double */
	InitialCurvature: number;
	/** @format double */
	InitialHeading: number;
	/** @format double */
	North: number;
	/** @format double */
	East: number;
	/** @format double */
	Up: number;
	/** @format double */
	Length: number;
	/**
	 * @deprecated
	 * @format double
	 */
	MaxSpeedKph: number;
	/** @format double */
	MaxSpeed: number;
	SegmentMetadata?: string | null;
	SegmentType?: string | null;
}

export interface CloudJobNotification {
	/** @format uuid */
	JobId: string;
	/**
	 * @deprecated
	 * @format uuid
	 */
	ImplementId?: string | null;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	AccountId: string;
	Message?: string | null;
}

export interface DeliveryMediumType {
	readonly Value?: string | null;
}

export interface DeployedLeaderFollowerMission {
	/** @format uuid */
	DeployedLeaderFollowerMissionId: string;
	MachineKey1: MachineKey;
	MachineKey2: MachineKey;
	/** @format uuid */
	DeployerUserId: string;
	/** @format date-time */
	DeployedTimeUTC: string;
	/** @format date-time */
	UpdateTimeUTC: string;
	/** @format uuid */
	readonly JobId: string;
	MissionState: DeployedLeaderFollowerMissionState;
	/** @format uuid */
	MissionID: string;
	MissionName?: string | null;
	/** @format uuid */
	CustomerID: string;
	/** @format uuid */
	ReferenceFarmID: string;
	Farm?: Farm;
	Obstacles?: FarmObstacle[] | null;
	FieldOptions?: FieldWorkOptions[] | null;
	ApplicationParameters?: string | null;
	/** @format date-time */
	LastModifiedUTC: string;
	/** @format date-time */
	CreatedUTC: string;
	UserDefinedCoverages?: SimplePoint[][] | null;
}

export interface DeployedSinglePathMission {
	/** @format uuid */
	MissionDeploymentID: string;
	TargetMachine: MachineKey;
	MissionState: DeployedSinglePathMissionCloudState;
	/** @format uuid */
	DeployerUserID?: string | null;
	/** @format date-time */
	DeployedTimeUTC: string;
	/** @format date-time */
	UpdateTimeUTC: string;
	/** @format uuid */
	JobID: string;
	/** @format double */
	PercentageComplete?: number | null;
	/** @format double */
	CoveredAreaMetresSquared?: number | null;
	ShapefileZipS3Key?: string | null;
	/** @format double */
	TurningSpeedKph?: number | null;
	/** @format double */
	ApproachSpeedKph?: number | null;
	/** @format uuid */
	MissionID: string;
	MissionName?: string | null;
	/** @format uuid */
	CustomerID: string;
	/** @format uuid */
	ReferencePathID: string;
	Path?: SimplePoint[] | null;
	PathActions?: ActionIndex[] | null;
	WorkAreas?: SimplePoint[][] | null;
	/** @format uuid */
	ReferenceFieldID: string;
	FieldBoundary?: AreaPolygon;
	/** @format double */
	TargetSpeedKph?: number | null;
	ApplicationParameters?: string | null;
	ClothoidPath?: ClothoidPath;
	/** @format date-time */
	LastModifiedUTC: string;
	/** @format uuid */
	ImplementCode: string;
	UsesInnerField?: boolean | null;
}

export interface DeployedSinglePathMissionQuery {
	/** @format date-time */
	StartDate: string;
	/** @format date-time */
	EndDate: string;
	/** @format uuid */
	MachineID: string;
	/** @format uuid */
	CustomerID: string;
}

export interface DeployedSinglePathMissionSummary {
	/** @format uuid */
	MissionID: string;
	MissionName?: string | null;
	/** @format uuid */
	MissionDeploymentID: string;
	TargetMachine: MachineKey;
	MissionState: DeployedSinglePathMissionCloudState;
	/** @format uuid */
	DeployerUserID: string;
	/** @format date-time */
	DeployedTimeUTC: string;
	/** @format date-time */
	UpdateTimeUTC: string;
	/** @format uuid */
	JobID: string;
	/** @format uuid */
	ReferenceFieldID: string;
	/** @format uuid */
	ReferencePathID: string;
	ApplicationParameters?: string | null;
}

export interface Farm {
	/** @format uuid */
	CustomerId: string;
	/** @format uuid */
	FarmId: string;
	Name?: string | null;
	VirtualEnvironmentName?: string | null;
	FarmBoundary?: SimplePoint[] | null;
	/** @format date-time */
	LastModifiedUTC: string;
}

export interface FarmField {
	/** @format uuid */
	CustomerId: string;
	/** @format uuid */
	FarmId: string;
	/** @format uuid */
	FieldId: string;
	Name?: string | null;
	FieldBoundary?: SimplePoint[] | null;
	/** @format date-time */
	LastModifiedUTC: string;
}

export interface FarmObstacle {
	/** @format uuid */
	CustomerId: string;
	/** @format uuid */
	FarmId: string;
	/** @format uuid */
	ObstacleId: string;
	Name?: string | null;
	ObstacleBoundary?: SimplePoint[] | null;
	/** @format date-time */
	LastModifiedUTC: string;
}

export interface FieldWorkOptions {
	Field?: FarmField;
	/** @format uuid */
	ImplementId: string;
	FieldMode: FieldMode;
	AdjacentMode: AdjacentMode;
	/** @format int32 */
	RowDirection: number;
	/** @format int32 */
	Headlands: number;
	RowOverlap: boolean;
	StartingPoint?: SimplePoint;
	PlannedPaths?: PlannedPathCollection[] | null;
}

export interface FlightPathMissionStatusMessage {
	/** @format uuid */
	mission_plan_id: string;
	mission_deploy_status: MissionDeployStatus;
	/** @format uuid */
	job_id: string;
}

export interface FullUserResponse {
	User?: AdminGetUserResponse;
	Groups?: string[] | null;
}

export interface GPSUpdateMessage {
	Location: GpsLocation;
	/** @format date-time */
	ReceivedTime: string;
}

/** GeoJSON Geometry */
export type Geometry =
	| Point
	| MultiPoint
	| LineString
	| MultiLineString
	| Polygon
	| MultiPolygon;

export interface GpsLocation {
	/** @format double */
	Longitude: number;
	/** @format double */
	Latitude: number;
	/** @format double */
	Bearing: number;
	/** @format double */
	Speed: number;
	/** @format float */
	Hdop: number;
	/** @format float */
	Pdop: number;
	/** @format int32 */
	NumberOfSVs: number;
	/** @format date-time */
	TimeStamp: string;
	/** @format int32 */
	MilisecondCount?: number | null;
	/** @format double */
	Elevation: number;
	/** @format double */
	RelativeElevation: number;
	Method: GnssMethod;
}

export interface ImplementCalibrationRequest {
	/** @format int32 */
	implement_up_time: number;
	/** @format int32 */
	implement_down_time: number;
	Message?: string | null;
}

export interface ImplementConnectorDto {
	/** @format int32 */
	ParentIndex: number;
	ConnectorType: ConnectorType;
}

export interface ImplementV2Model {
	/** @format uuid */
	ImplementId: string;
	ImplementName: string;
	/** @format uuid */
	CustomerId: string;
	Bins: BinDto[];
	Booms: BoomDto[];
	Sections: SectionDto[];
	Connectors: ImplementConnectorDto[];
	ImplementType?: ImplementType;
	NavigationReferencePoint: ReferencePoint3D;
	ConnectorReferencePointTractor: ReferencePoint2D;
	ConnectorReferencePointImplement: ReferencePoint2D;
	ApplicationParameters: string;
}

export interface JobInfo {
	/** @format uuid */
	JobId: string;
	/** @format uuid */
	ImplementId: string;
}

/** GeoJSON LineString */
export interface LineString {
	type?: "LineString";
	coordinates?: Position[];
}

export interface ListUsersInGroupResponse {
	ResponseMetadata?: ResponseMetadata;
	/** @format int64 */
	ContentLength: number;
	HttpStatusCode: HttpStatusCode;
	NextToken?: string | null;
	Users?: UserType[] | null;
}

export interface ListUsersWithGroupsResponse {
	PaginationToken?: string | null;
	UsersWithGroups?: UserWithGroups[] | null;
}

export interface MFAOptionType {
	AttributeName?: string | null;
	DeliveryMedium?: DeliveryMediumType;
}

export interface MachineDetails {
	/** @format uuid */
	DealerId: string;
	DealerName?: string | null;
	/** @format uuid */
	OrganizationId: string;
	OrganizationName?: string | null;
	MachineMarkerStatus?: MachineMarkerStatus[] | null;
}

export interface MachineKey {
	/** @format uuid */
	machineId: string;
	/** @minLength 1 */
	MachineName: string;
	/** @format uuid */
	AccountID: string;
}

export interface MachineMarkerStatus {
	/** @format date-time */
	SentUTC: string;
	IsOnline: boolean;
	Location?: GPSUpdateMessage;
	/** @format double */
	SpeedKph: number;
	GPSFixStatus: GPSFixStatus;
	RosState: RosState;
	/** @format int32 */
	AlarmStatus: number;
	Key: MachineKey;
	MachineType?: LeaderFollowerMachineType;
	ActiveMachine: boolean;
	/** @format int32 */
	MachineHours?: number | null;
	RosApplicationCache?: Record<string, string>;
	UIApplicationCache?: Record<string, string>;
	ApplicationSpecific?: Record<string, string>;
}

export interface Mission {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	AccountId: string;
	/** @format uuid */
	Field?: string | null;
	MissionType?: MissionType;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
	State: DeployedSinglePathMissionCloudState;
	Name: string;
	/** @deprecated */
	Machines?: string[] | null;
	Parameters: MissionParameters;
	ApplicationParameters?: string | null;
}

export interface MissionParameters {
	/** @format double */
	TargetSpeedKph?: number | null;
	/** @format double */
	TurningSpeedKph?: number | null;
	/** @format double */
	ApproachSpeedKph?: number | null;
	/** @format double */
	CoveredMetersSquared?: number | null;
	/** @format double */
	PercentageComplete?: number | null;
	UsesInnerField?: boolean | null;
	/** @format uuid */
	DeployerUserID?: string | null;
}

export interface MissionStatusMessage {
	Key: MachineKey;
	/** @format date-time */
	SentUTC: string;
	RosMissionStatus?: RosMissionStatusMessage;
	FlightPathMissionStatus?: FlightPathMissionStatusMessage;
	AutoTransitionRequirements?: RosTransitionRequirementsMessage;
}

export interface MissionSummary {
	/** @format uuid */
	Id: string;
	Name: string;
	MissionType?: MissionType;
	Machines?: string[] | null;
	Boundaries?: BoundarySummary[] | null;
	BoundaryThumbnail?: string | null;
	/** @format uuid */
	Field?: string | null;
	/** @format double */
	FieldAreaM2?: number | null;
	ImplementName?: string | null;
	/** @format uuid */
	ImplementId?: string | null;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
}

/** GeoJSON MultiLineString */
export interface MultiLineString {
	type?: "MultiLineString";
	coordinates?: LineString[];
}

/** GeoJSON MultiPoint */
export interface MultiPoint {
	type?: "MultiPoint";
	coordinates?: Position[];
}

/** GeoJSON MultiPolygon */
export interface MultiPolygon {
	type?: "MultiPolygon";
	coordinates?: Position[][][];
}

export interface NewAccountRequest {
	Account?: Account;
	AccountOwner?: User;
	GreCaptchaResponse?: string | null;
}

export interface NewMission {
	Name: string;
	/** @deprecated */
	Machines?: string[] | null;
	Boundaries?: string[] | null;
	PointsOfInterest?: string[] | null;
	Paths?: string[] | null;
	/**
	 * @deprecated
	 * @format uuid
	 */
	Implement?: string | null;
	/** @format uuid */
	Field?: string | null;
	Parameters: MissionParameters;
	ApplicationParameters?: string | null;
	State?: DeployedSinglePathMissionCloudState;
	MissionType?: MissionType;
}

export interface PathMetadata {
	Created?: string | null;
	Datum?: string | null;
	ID?: string | null;
}

export interface PathOrigin {
	/** @format double */
	Alt: number;
	/** @format double */
	Lat: number;
	/** @format double */
	Long: number;
}

export interface PlannedPathCollection {
	Label?: string | null;
	PlannedPath?: SimplePoint[] | null;
}

/** GeoJSON Point */
export interface Point {
	type?: "Point";
	/** Point in 3D space */
	coordinates?: Position;
}

/** GeoJSON Polygon */
export interface Polygon {
	type?: "Polygon";
	coordinates?: Position[][];
}

/**
 * Point in 3D space
 * @maxItems 3
 * @minItems 2
 */
export type Position = number[];

export interface ProblemDetails {
	type?: string | null;
	title?: string | null;
	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	[key: string]: any;
}

export interface ReferencePoint2D {
	/** @format double */
	ReferencePointX: number;
	/** @format double */
	ReferencePointZ: number;
}

export interface ReferencePoint3D {
	/** @format double */
	ReferencePointX: number;
	/** @format double */
	ReferencePointY: number;
	/** @format double */
	ReferencePointZ: number;
}

export interface ResponseMetadata {
	RequestId?: string | null;
	readonly Metadata?: Record<string, string | null>;
	ChecksumAlgorithm: CoreChecksumAlgorithm;
	ChecksumValidationStatus: ChecksumValidationStatus;
}

export interface RosMissionStatusMessage {
	/** @format uuid */
	deployed_mission_id: string;
	mission_name?: string | null;
	mission_status: RosMissionStatus;
	coverage_requested: boolean;
	/** @format double */
	percent_progress: number;
	/** @format double */
	time_remaining_sec: number;
	section_control_requested: boolean;
}

export interface RosTransitionRequirementsMessage {
	requirements?: TransitionRequirement[] | null;
}

export interface SectionDto {
	/** @format int32 */
	readonly ElementIndex: number;
	/** @format int32 */
	readonly ParentIndex: number;
	/** @format double */
	ElementWorkingWidth: number;
	/** @format double */
	ActualWorkingLength: number;
	DeviceElementReferencePoint: ReferencePoint3D;
	/** @format int32 */
	SectionControlTurnOnMilliseconds: number;
	/** @format int32 */
	SectionControlTurnOffMilliseconds: number;
}

export interface SimplePath {
	/** @format uuid */
	PathID: string;
	/** @format uuid */
	CustomerID: string;
	/** @format uuid */
	FieldID: string;
	Path?: SimplePoint[] | null;
	WorkAreas?: SimplePoint[][] | null;
	/** @format double */
	PathLengthMeters: number;
	/** @format double */
	StrokeOpacity: number;
	/** @format int32 */
	StrokeWeight: number;
	Name?: string | null;
	/** @format date-time */
	LastModifiedUTC: string;
}

export interface SimplePathSummary {
	/** @format uuid */
	PathID: string;
	/** @format uuid */
	CustomerID: string;
	/** @format uuid */
	FieldID: string;
	/** @format double */
	PathLengthMeters: number;
	Name?: string | null;
	/** @format date-time */
	LastModifiedUTC: string;
}

export interface SimplePoint {
	/** @format double */
	Lat: number;
	/** @format double */
	Long: number;
	/** @format double */
	Alt: number;
	Label?: string | null;
}

export interface TransitionRequirement {
	key?: string | null;
	value: boolean;
}

export interface UpdateUser {
	userName?: string | null;
	accountId?: string | null;
	Groups?: string[] | null;
	Attributes?: Record<string, string | null>;
}

export interface User {
	userName?: string | null;
	groupName?: string | null;
	groupNames?: string[] | null;
	accountId?: string | null;
}

export interface UserStatusType {
	readonly Value?: string | null;
}

export interface UserType {
	Attributes?: AttributeType[] | null;
	Enabled?: boolean | null;
	MFAOptions?: MFAOptionType[] | null;
	/** @format date-time */
	UserCreateDate?: string | null;
	/** @format date-time */
	UserLastModifiedDate?: string | null;
	Username?: string | null;
	UserStatus?: UserStatusType;
}

export interface UserWithGroups {
	User?: UserType;
	Groups?: string[] | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseFormat;
	/** request body */
	body?: unknown;
	/** base url */
	baseUrl?: string;
	/** request cancellation token */
	cancelToken?: CancelToken;
}

export type RequestParams = Omit<
	FullRequestParams,
	"body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
	baseUrl?: string;
	baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
	securityWorker?: (
		securityData: SecurityDataType | null,
	) => Promise<RequestParams | void> | RequestParams | void;
	customFetch?: typeof fetch;
}

export interface HttpResponse<
	D extends unknown,
	E extends unknown = unknown,
> extends Response {
	data: D;
	error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
	Json = "application/json",
	JsonApi = "application/vnd.api+json",
	FormData = "multipart/form-data",
	UrlEncoded = "application/x-www-form-urlencoded",
	Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
	public baseUrl: string = "";
	private securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
	private abortControllers = new Map<CancelToken, AbortController>();
	private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
		fetch(...fetchParams);

	private baseApiParams: RequestParams = {
		credentials: "same-origin",
		headers: {},
		redirect: "follow",
		referrerPolicy: "no-referrer",
	};

	constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
		Object.assign(this, apiConfig);
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	protected encodeQueryParam(key: string, value: any) {
		const encodedKey = encodeURIComponent(key);
		return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
	}

	protected addQueryParam(query: QueryParamsType, key: string) {
		return this.encodeQueryParam(key, query[key]);
	}

	protected addArrayQueryParam(query: QueryParamsType, key: string) {
		const value = query[key];
		return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
	}

	protected toQueryString(rawQuery?: QueryParamsType): string {
		const query = rawQuery || {};
		const keys = Object.keys(query).filter(
			key => "undefined" !== typeof query[key],
		);
		return keys
			.map(key =>
				Array.isArray(query[key])
					? this.addArrayQueryParam(query, key)
					: this.addQueryParam(query, key),
			)
			.join("&");
	}

	protected addQueryParams(rawQuery?: QueryParamsType): string {
		const queryString = this.toQueryString(rawQuery);
		return queryString ? `?${queryString}` : "";
	}

	private contentFormatters: Record<ContentType, (input: any) => any> = {
		[ContentType.Json]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.JsonApi]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.Text]: (input: any) =>
			input !== null && typeof input !== "string"
				? JSON.stringify(input)
				: input,
		[ContentType.FormData]: (input: any) => {
			if (input instanceof FormData) {
				return input;
			}

			return Object.keys(input || {}).reduce((formData, key) => {
				const property = input[key];
				formData.append(
					key,
					property instanceof Blob
						? property
						: typeof property === "object" && property !== null
							? JSON.stringify(property)
							: `${property}`,
				);
				return formData;
			}, new FormData());
		},
		[ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
	};

	protected mergeRequestParams(
		params1: RequestParams,
		params2?: RequestParams,
	): RequestParams {
		return {
			...this.baseApiParams,
			...params1,
			...(params2 || {}),
			headers: {
				...(this.baseApiParams.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	protected createAbortSignal = (
		cancelToken: CancelToken,
	): AbortSignal | undefined => {
		if (this.abortControllers.has(cancelToken)) {
			const abortController = this.abortControllers.get(cancelToken);
			if (abortController) {
				return abortController.signal;
			}
			return void 0;
		}

		const abortController = new AbortController();
		this.abortControllers.set(cancelToken, abortController);
		return abortController.signal;
	};

	public abortRequest = (cancelToken: CancelToken) => {
		const abortController = this.abortControllers.get(cancelToken);

		if (abortController) {
			abortController.abort();
			this.abortControllers.delete(cancelToken);
		}
	};

	public request = async <T = any, E = any>({
		body,
		secure,
		path,
		type,
		query,
		format,
		baseUrl,
		cancelToken,
		...params
	}: FullRequestParams): Promise<HttpResponse<T, E>> => {
		const secureParams =
			((typeof secure === "boolean"
				? secure
				: this.baseApiParams.secure) &&
				this.securityWorker &&
				(await this.securityWorker(this.securityData))) ||
			{};
		const requestParams = this.mergeRequestParams(params, secureParams);
		const queryString = query && this.toQueryString(query);
		const payloadFormatter =
			this.contentFormatters[type || ContentType.Json];
		const responseFormat = format || requestParams.format;

		return this.customFetch(
			`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
			{
				...requestParams,
				headers: {
					...(requestParams.headers || {}),
					...(type && type !== ContentType.FormData
						? { "Content-Type": type }
						: {}),
				},
				signal:
					(cancelToken
						? this.createAbortSignal(cancelToken)
						: requestParams.signal) || null,
				body:
					typeof body === "undefined" || body === null
						? null
						: payloadFormatter(body),
			},
		).then(async response => {
			const r = response as HttpResponse<T, E>;
			r.data = null as unknown as T;
			r.error = null as unknown as E;

			const responseToParse = responseFormat
				? response.clone()
				: response;
			const data = !responseFormat
				? r
				: await responseToParse[responseFormat]()
						.then(data => {
							if (r.ok) {
								r.data = data;
							} else {
								r.error = data;
							}
							return r;
						})
						.catch(e => {
							r.error = e as E;
							return r;
						});

			if (cancelToken) {
				this.abortControllers.delete(cancelToken);
			}

			if (!response.ok) {
				const error = Object.assign(
					new Error(
						`HTTP ${data.status}: ${data.statusText || "Error"}`,
					),
					{
						status: data.status,
						statusText: data.statusText,
						data: data.data,
						error: data.error,
						response: data,
						json: data.json.bind(data),
						text: data.text.bind(data),
					},
				);

				throw error;
			}
			return data;
		});
	};
}

/**
 * @title FlightPath.WebApiSwagger, Version=175.0.0.0, Culture=neutral, PublicKeyToken=null
 * @version 1.0
 */
export class Api<
	SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
	alarm = {
		/**
		 * No description
		 *
		 * @tags AlarmLambda, Only lambda
		 * @name TableList
		 * @request GET:/alarm/table
		 */
		tableList: (
			query: {
				machines: string;
				userName: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AlarmModel[], any>({
				path: `/alarm/table`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags AlarmLambda, Only lambda
		 * @name AcknowledgeUpdate
		 * @request PUT:/alarm/acknowledge
		 */
		acknowledgeUpdate: (data: AlarmModel[], params: RequestParams = {}) =>
			this.request<boolean, any>({
				path: `/alarm/acknowledge`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	applicationDataKeys = {
		/**
		 * No description
		 *
		 * @tags Application Data, Not in lambdas
		 * @name ApplicationDataKeysList
		 * @request GET:/application-data-keys
		 */
		applicationDataKeysList: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/application-data-keys`,
				method: "GET",
				...params,
			}),
	};
	applicationData = {
		/**
		 * No description
		 *
		 * @tags Application Data, Not in lambdas
		 * @name ApplicationDataList
		 * @request GET:/application-data
		 */
		applicationDataList: (
			query: {
				key: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/application-data`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Application Data, Not in lambdas
		 * @name ApplicationDataCreate
		 * @request POST:/application-data
		 */
		applicationDataCreate: (
			query: {
				key: string;
			},
			data: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/application-data`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Text,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Application Data, Not in lambdas
		 * @name ApplicationDataDelete
		 * @request DELETE:/application-data
		 */
		applicationDataDelete: (
			query: {
				key: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/application-data`,
				method: "DELETE",
				query: query,
				...params,
			}),
	};
	missions = {
		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CoverageList
		 * @request GET:/missions/{missionId}/coverage
		 */
		coverageList: (missionId: string, params: RequestParams = {}) =>
			this.request<MultiPolygon, ProblemDetails>({
				path: `/missions/${missionId}/coverage`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name DrivenPathList
		 * @request GET:/missions/{missionId}/driven-path
		 */
		drivenPathList: (missionId: string, params: RequestParams = {}) =>
			this.request<MultiLineString, ProblemDetails>({
				path: `/missions/${missionId}/driven-path`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name MissionsCreate
		 * @request POST:/missions
		 */
		missionsCreate: (data: NewMission, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/missions`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name MissionsList
		 * @request GET:/missions
		 */
		missionsList: (params: RequestParams = {}) =>
			this.request<Mission[], any>({
				path: `/missions`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name ResumeUpdate
		 * @request PUT:/missions/{missionId}/resume
		 */
		resumeUpdate: (missionId: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/missions/${missionId}/resume`,
				method: "PUT",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name StopUpdate
		 * @request PUT:/missions/{missionId}/stop
		 */
		stopUpdate: (missionId: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/missions/${missionId}/stop`,
				method: "PUT",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name MissionsDetail
		 * @request GET:/missions/{missionId}
		 */
		missionsDetail: (missionId: string, params: RequestParams = {}) =>
			this.request<Mission, any>({
				path: `/missions/${missionId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name MissionsDelete
		 * @request DELETE:/missions/{missionId}
		 */
		missionsDelete: (missionId: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/missions/${missionId}`,
				method: "DELETE",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name ActiveList
		 * @request GET:/missions/active
		 */
		activeList: (params: RequestParams = {}) =>
			this.request<Mission[], any>({
				path: `/missions/active`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name BoundariesList
		 * @request GET:/missions/{missionId}/boundaries
		 */
		boundariesList: (
			missionId: string,
			query?: {
				boundaryType?: BoundaryType;
			},
			params: RequestParams = {},
		) =>
			this.request<Boundary[], any>({
				path: `/missions/${missionId}/boundaries`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name BoundariesCreate
		 * @request POST:/missions/{missionId}/boundaries
		 */
		boundariesCreate: (
			missionId: string,
			data: string[],
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/missions/${missionId}/boundaries`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name ImplementList
		 * @request GET:/missions/{missionId}/implement
		 */
		implementList: (missionId: string, params: RequestParams = {}) =>
			this.request<ImplementV2Model, any>({
				path: `/missions/${missionId}/implement`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New missions
		 * @name SummariesList
		 * @request GET:/missions/summaries
		 */
		summariesList: (params: RequestParams = {}) =>
			this.request<Record<string, MissionSummary[]>, any>({
				path: `/missions/summaries`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	health = {
		/**
		 * No description
		 *
		 * @tags FlightPath.WebApiSwagger, Version=175.0.0.0, Culture=neutral, PublicKeyToken=null
		 * @name HealthList
		 * @request GET:/health
		 */
		healthList: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/health`,
				method: "GET",
				...params,
			}),
	};
	simplepaths = {
		/**
		 * No description
		 *
		 * @tags FlightPathLambda, Only lambda
		 * @name SimplepathsCreate
		 * @request POST:/simplepaths
		 */
		simplepathsCreate: (data: SimplePath, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/simplepaths`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FlightPathLambda, Only lambda
		 * @name UploadlistCreate
		 * @request POST:/simplepaths/uploadlist
		 */
		uploadlistCreate: (data: SimplePath[], params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/simplepaths/uploadlist`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FlightPathLambda, Only lambda
		 * @name PathidDetail
		 * @request GET:/simplepaths/pathid/{accountId}
		 */
		pathidDetail: (
			accountId: string,
			query: {
				/** @format uuid */
				pathId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<SimplePath, any>({
				path: `/simplepaths/pathid/${accountId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FlightPathLambda, Only lambda
		 * @name CustomeridDetail
		 * @request GET:/simplepaths/customerid/{accountId}
		 */
		customeridDetail: (accountId: string, params: RequestParams = {}) =>
			this.request<SimplePath[], any>({
				path: `/simplepaths/customerid/${accountId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FlightPathLambda, Only lambda
		 * @name SummaryCustomeridDetail
		 * @request GET:/simplepaths/summary/customerid/{accountId}
		 */
		summaryCustomeridDetail: (
			accountId: string,
			params: RequestParams = {},
		) =>
			this.request<SimplePathSummary[], any>({
				path: `/simplepaths/summary/customerid/${accountId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FlightPathLambda, Only lambda
		 * @name FieldidDetail
		 * @request GET:/simplepaths/fieldid/{accountId}
		 */
		fieldidDetail: (
			accountId: string,
			query: {
				/** @format uuid */
				fieldId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<SimplePath[], any>({
				path: `/simplepaths/fieldid/${accountId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags FlightPathLambda, Only lambda
		 * @name SimplepathsDelete
		 * @request DELETE:/simplepaths/{accountId}
		 */
		simplepathsDelete: (
			accountId: string,
			query: {
				/** @format uuid */
				pathId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/simplepaths/${accountId}`,
				method: "DELETE",
				query: query,
				...params,
			}),
	};
	general = {
		/**
		 * No description
		 *
		 * @tags General operations, Only lambda
		 * @name AvailableMachinesList
		 * @request GET:/general/available-machines
		 */
		availableMachinesList: (params: RequestParams = {}) =>
			this.request<MachineKey[], any>({
				path: `/general/available-machines`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags General operations, Only lambda
		 * @name AllAvailableMachinesList
		 * @request GET:/general/all-available-machines
		 */
		allAvailableMachinesList: (params: RequestParams = {}) =>
			this.request<MachineDetails[], any>({
				path: `/general/all-available-machines`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags General operations, Only lambda
		 * @name MachineStatusesCreate
		 * @request POST:/general/machine-statuses
		 */
		machineStatusesCreate: (data: string[], params: RequestParams = {}) =>
			this.request<MachineMarkerStatus[], any>({
				path: `/general/machine-statuses`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	implementsMultiboom = {
		/**
		 * No description
		 *
		 * @tags Implement operations, Multi-Boom Precision ag
		 * @name ImplementsMultiboomCreate
		 * @request POST:/implements-multiboom/{accountId}
		 */
		implementsMultiboomCreate: (
			accountId: string,
			data: ImplementV2Model,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/implements-multiboom/${accountId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Implement operations, Multi-Boom Precision ag
		 * @name ImplementsMultiboomDetail
		 * @request GET:/implements-multiboom/{accountId}
		 */
		implementsMultiboomDetail: (
			accountId: string,
			params: RequestParams = {},
		) =>
			this.request<ImplementV2Model[], any>({
				path: `/implements-multiboom/${accountId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Implement operations, Multi-Boom Precision ag
		 * @name ImplementsMultiboomDetail2
		 * @request GET:/implements-multiboom/{accountId}/{implementId}
		 * @originalName implementsMultiboomDetail
		 * @duplicate
		 */
		implementsMultiboomDetail2: (
			accountId: string,
			implementId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/implements-multiboom/${accountId}/${implementId}`,
				method: "GET",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Implement operations, Multi-Boom Precision ag
		 * @name CalibrationUpdate
		 * @request PUT:/implements-multiboom/calibration
		 */
		calibrationUpdate: (
			data: ImplementCalibrationRequest,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/implements-multiboom/calibration`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),
	};
	jobs = {
		/**
		 * No description
		 *
		 * @tags Job operations
		 * @name PendingRosSingleMissionDetail
		 * @request GET:/jobs/pending-ros-single-mission/{missionplanid}
		 */
		pendingRosSingleMissionDetail: (
			missionplanid: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/jobs/pending-ros-single-mission/${missionplanid}`,
				method: "GET",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations
		 * @name PendingRosSingleMissionClothoidList
		 * @request GET:/jobs/pending-ros-single-mission/{missionplanid}/clothoid
		 */
		pendingRosSingleMissionClothoidList: (
			missionplanid: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/jobs/pending-ros-single-mission/${missionplanid}/clothoid`,
				method: "GET",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations
		 * @name PendingRosLeaderFollowerMissionDetail
		 * @request GET:/jobs/pending-ros-leader-follower-mission/{missionplanid}
		 */
		pendingRosLeaderFollowerMissionDetail: (
			missionplanid: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/jobs/pending-ros-leader-follower-mission/${missionplanid}`,
				method: "GET",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations
		 * @name ServicePointDetail
		 * @request GET:/jobs/service-point/{missionplanid}
		 */
		servicePointDetail: (
			missionplanid: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/jobs/service-point/${missionplanid}`,
				method: "GET",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name MissionStatusAutoTransitionList
		 * @request GET:/jobs/mission-status-auto-transition
		 */
		missionStatusAutoTransitionList: (
			query: {
				/** @format uuid */
				MachineId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MissionStatusMessage, any>({
				path: `/jobs/mission-status-auto-transition`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name MissionStatusAutoTransitionDetail
		 * @request GET:/jobs/mission-status-auto-transition/{accountId}
		 */
		missionStatusAutoTransitionDetail: (
			accountId: string,
			query: {
				/** @format uuid */
				MachineId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MissionStatusMessage, any>({
				path: `/jobs/mission-status-auto-transition/${accountId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name ActiveSinglePathMissionsList
		 * @request GET:/jobs/active-single-path-missions
		 */
		activeSinglePathMissionsList: (params: RequestParams = {}) =>
			this.request<DeployedSinglePathMission[], any>({
				path: `/jobs/active-single-path-missions`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name ActiveSinglePathMissionsDetail
		 * @request GET:/jobs/active-single-path-missions/{accountId}
		 */
		activeSinglePathMissionsDetail: (
			accountId: string,
			params: RequestParams = {},
		) =>
			this.request<DeployedSinglePathMission[], any>({
				path: `/jobs/active-single-path-missions/${accountId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name DeployedSinglePathMissionCreate
		 * @request POST:/jobs/deployed-single-path-mission
		 */
		deployedSinglePathMissionCreate: (
			data: DeployedSinglePathMission,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/jobs/deployed-single-path-mission`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name DeployedSinglePathMissionDelete
		 * @request DELETE:/jobs/deployed-single-path-mission
		 */
		deployedSinglePathMissionDelete: (
			data: DeployedSinglePathMission,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/jobs/deployed-single-path-mission`,
				method: "DELETE",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name DeployedSinglePathMissionList
		 * @request GET:/jobs/deployed-single-path-mission
		 */
		deployedSinglePathMissionList: (params: RequestParams = {}) =>
			this.request<DeployedSinglePathMission[], any>({
				path: `/jobs/deployed-single-path-mission`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name DeployedSinglePathMissionCreate2
		 * @request POST:/jobs/deployed-single-path-mission/{accountId}
		 * @originalName deployedSinglePathMissionCreate
		 * @duplicate
		 */
		deployedSinglePathMissionCreate2: (
			accountId: string,
			data: DeployedSinglePathMission,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/jobs/deployed-single-path-mission/${accountId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name DeployedSinglePathMissionDelete2
		 * @request DELETE:/jobs/deployed-single-path-mission/{accountId}
		 * @originalName deployedSinglePathMissionDelete
		 * @duplicate
		 */
		deployedSinglePathMissionDelete2: (
			accountId: string,
			data: DeployedSinglePathMission,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/jobs/deployed-single-path-mission/${accountId}`,
				method: "DELETE",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name DeployedSinglePathMissionDetail
		 * @request GET:/jobs/deployed-single-path-mission/{accountId}
		 */
		deployedSinglePathMissionDetail: (
			accountId: string,
			params: RequestParams = {},
		) =>
			this.request<DeployedSinglePathMission[], any>({
				path: `/jobs/deployed-single-path-mission/${accountId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name CancelDeployedSinglePathMissionCreate
		 * @request POST:/jobs/cancel-deployed-single-path-mission
		 */
		cancelDeployedSinglePathMissionCreate: (
			data: DeployedSinglePathMission,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/jobs/cancel-deployed-single-path-mission`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name CancelDeployedSinglePathMissionCreate2
		 * @request POST:/jobs/cancel-deployed-single-path-mission/{accountId}
		 * @originalName cancelDeployedSinglePathMissionCreate
		 * @duplicate
		 */
		cancelDeployedSinglePathMissionCreate2: (
			accountId: string,
			data: DeployedSinglePathMission,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/jobs/cancel-deployed-single-path-mission/${accountId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name CancelDeployedSinglePathMissionCloudPrecisionAgCreate
		 * @request POST:/jobs/cancel-deployed-single-path-mission/cloud-precision-ag/{accountId}
		 */
		cancelDeployedSinglePathMissionCloudPrecisionAgCreate: (
			accountId: string,
			data: DeployedSinglePathMission,
			params: RequestParams = {},
		) =>
			this.request<string, string>({
				path: `/jobs/cancel-deployed-single-path-mission/cloud-precision-ag/${accountId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name CompletedDeployedSinglePathMissionCreate
		 * @request POST:/jobs/completed-deployed-single-path-mission
		 */
		completedDeployedSinglePathMissionCreate: (
			data: DeployedSinglePathMissionQuery,
			params: RequestParams = {},
		) =>
			this.request<DeployedSinglePathMission[], any>({
				path: `/jobs/completed-deployed-single-path-mission`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Job operations, Only lambda
		 * @name CompletedDeployedSinglePathMissionSummaryCreate
		 * @request POST:/jobs/completed-deployed-single-path-mission/summary
		 */
		completedDeployedSinglePathMissionSummaryCreate: (
			data: DeployedSinglePathMissionQuery,
			params: RequestParams = {},
		) =>
			this.request<DeployedSinglePathMissionSummary[], any>({
				path: `/jobs/completed-deployed-single-path-mission/summary`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),
	};
	deployedleaderfollowermissions = {
		/**
		 * No description
		 *
		 * @tags Leader Follower mission
		 * @name DeployedLeaderFollowerMissionCreate
		 * @request POST:/deployedleaderfollowermissions/deployed-leader-follower-mission/{accountId}
		 */
		deployedLeaderFollowerMissionCreate: (
			accountId: string,
			data: DeployedLeaderFollowerMission,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/deployedleaderfollowermissions/deployed-leader-follower-mission/${accountId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Leader Follower mission
		 * @name DeployedLeaderFollowerMissionDetail
		 * @request GET:/deployedleaderfollowermissions/deployed-leader-follower-mission/{accountId}
		 */
		deployedLeaderFollowerMissionDetail: (
			accountId: string,
			query: {
				/** @format uuid */
				MissionDeploymentID: string;
			},
			params: RequestParams = {},
		) =>
			this.request<DeployedLeaderFollowerMission, any>({
				path: `/deployedleaderfollowermissions/deployed-leader-follower-mission/${accountId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Leader Follower mission
		 * @name CancelDeployedLeaderFollowerMissionCreate
		 * @request POST:/deployedleaderfollowermissions/cancel-deployed-leader-follower-mission/{accountId}
		 */
		cancelDeployedLeaderFollowerMissionCreate: (
			accountId: string,
			data: DeployedLeaderFollowerMission,
			params: RequestParams = {},
		) =>
			this.request<string, any>({
				path: `/deployedleaderfollowermissions/cancel-deployed-leader-follower-mission/${accountId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Leader Follower mission
		 * @name DeployedleaderfollowermissionsDetail
		 * @request GET:/deployedleaderfollowermissions/{accountId}
		 */
		deployedleaderfollowermissionsDetail: (
			accountId: string,
			params: RequestParams = {},
		) =>
			this.request<DeployedLeaderFollowerMission[], any>({
				path: `/deployedleaderfollowermissions/${accountId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Leader Follower mission
		 * @name ActiveLeaderFollowerMissionsDetail
		 * @request GET:/deployedleaderfollowermissions/active-leader-follower-missions/{accountId}
		 */
		activeLeaderFollowerMissionsDetail: (
			accountId: string,
			params: RequestParams = {},
		) =>
			this.request<DeployedLeaderFollowerMission[], any>({
				path: `/deployedleaderfollowermissions/active-leader-follower-missions/${accountId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Leader Follower mission
		 * @name DeployedLeaderFollowerMissionDelete
		 * @request DELETE:/deployedleaderfollowermissions/deployed-leader-follower-mission/{accountId}/{missionDeploymentID}
		 */
		deployedLeaderFollowerMissionDelete: (
			accountId: string,
			missionDeploymentId: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/deployedleaderfollowermissions/deployed-leader-follower-mission/${accountId}/${missionDeploymentId}`,
				method: "DELETE",
				...params,
			}),
	};
	mapServer = {
		/**
		 * No description
		 *
		 * @tags Map server, Not in lambdas
		 * @name MapTilesDetail
		 * @request GET:/map-server/map-tiles/{layertype}
		 */
		mapTilesDetail: (
			layertype: LayerType,
			query: {
				/** @format uuid */
				accountId: string;
				/** @format uuid */
				missionDeploymentID: string;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/map-server/map-tiles/${layertype}`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Map server, Not in lambdas
		 * @name DrivenPathList
		 * @request GET:/map-server/driven-path
		 */
		drivenPathList: (
			query: {
				/** @format uuid */
				missionDeploymentId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<Blob, string>({
				path: `/map-server/driven-path`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Map server, Not in lambdas
		 * @name DrivenPathDeltaList
		 * @request GET:/map-server/driven-path/delta
		 */
		drivenPathDeltaList: (params: RequestParams = {}) =>
			this.request<Blob, string>({
				path: `/map-server/driven-path/delta`,
				method: "GET",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Map server, Not in lambdas
		 * @name MapTilesEnuDetail
		 * @request GET:/map-server/map-tiles/enu/{layertype}
		 */
		mapTilesEnuDetail: (
			layertype: LayerType,
			query: {
				/** @format uuid */
				missionDeploymentID: string;
				/** @format double */
				baseLatitude: number;
				/** @format double */
				baseLongitude: number;
				/** @format double */
				baseAltitude: number;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/map-server/map-tiles/enu/${layertype}`,
				method: "GET",
				query: query,
				...params,
			}),
	};
	boundaries = {
		/**
		 * No description
		 *
		 * @tags New fields
		 * @name BoundariesCreate
		 * @request POST:/boundaries
		 */
		boundariesCreate: (data: Boundary[], params: RequestParams = {}) =>
			this.request<void, ProblemDetails>({
				path: `/boundaries`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New fields
		 * @name BoundariesUpdate
		 * @request PUT:/boundaries
		 */
		boundariesUpdate: (data: BoundaryUpdate, params: RequestParams = {}) =>
			this.request<void, ProblemDetails>({
				path: `/boundaries`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags New fields
		 * @name BoundariesDelete
		 * @request DELETE:/boundaries/{boundaryId}
		 */
		boundariesDelete: (boundaryId: string, params: RequestParams = {}) =>
			this.request<void, ProblemDetails>({
				path: `/boundaries/${boundaryId}`,
				method: "DELETE",
				...params,
			}),
	};
	precisionAg = {
		/**
		 * No description
		 *
		 * @tags Precision ag, Only lambda
		 * @name SendMachineJobNotificationCreate
		 * @request POST:/precision-ag/send-machine-job-notification/{accountId}
		 */
		sendMachineJobNotificationCreate: (
			accountId: string,
			data: CloudJobNotification,
			params: RequestParams = {},
		) =>
			this.request<string, string>({
				path: `/precision-ag/send-machine-job-notification/${accountId}`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Precision ag, Only lambda
		 * @name ActiveJobIdForMachinesDetail
		 * @request GET:/precision-ag/active-job-id-for-machines/{accountId}
		 */
		activeJobIdForMachinesDetail: (
			accountId: string,
			query: {
				/** @format uuid */
				MachineId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<JobInfo, string>({
				path: `/precision-ag/active-job-id-for-machines/${accountId}`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
	singlepathmissions = {
		/**
		 * No description
		 *
		 * @tags Single machine mission, Only lambda
		 * @name SinglepathmissionsDelete
		 * @request DELETE:/singlepathmissions
		 */
		singlepathmissionsDelete: (
			query: {
				/** @format uuid */
				MissionID: string;
			},
			params: RequestParams = {},
		) =>
			this.request<DeployedSinglePathMission, any>({
				path: `/singlepathmissions`,
				method: "DELETE",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Single machine mission, Only lambda
		 * @name SinglepathmissionsDelete2
		 * @request DELETE:/singlepathmissions/{accountId}
		 * @originalName singlepathmissionsDelete
		 * @duplicate
		 */
		singlepathmissionsDelete2: (
			accountId: string,
			query: {
				/** @format uuid */
				MissionID: string;
			},
			params: RequestParams = {},
		) =>
			this.request<DeployedSinglePathMission, any>({
				path: `/singlepathmissions/${accountId}`,
				method: "DELETE",
				query: query,
				format: "json",
				...params,
			}),
	};
	umc = {
		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name UsersList
		 * @request GET:/umc/users
		 */
		usersList: (
			query: {
				paginationToken: string;
				/** @format int32 */
				limit: number;
			},
			params: RequestParams = {},
		) =>
			this.request<ListUsersWithGroupsResponse, any>({
				path: `/umc/users`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name GetAllUsersGroup
		 * @request GET:/umc/users/group
		 */
		getAllUsersGroup: (
			query: {
				groupName: string;
				nextToken: string;
				/** @format int32 */
				limit: number;
			},
			params: RequestParams = {},
		) =>
			this.request<ListUsersInGroupResponse, any>({
				path: `/umc/users/group`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name UserList
		 * @request GET:/umc/user
		 */
		userList: (
			query: {
				userName: string;
			},
			params: RequestParams = {},
		) =>
			this.request<FullUserResponse, any>({
				path: `/umc/user`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name UserCreate
		 * @request POST:/umc/user
		 */
		userCreate: (data: User, params: RequestParams = {}) =>
			this.request<AdminCreateUserResponse, any>({
				path: `/umc/user`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name UserDelete
		 * @request DELETE:/umc/user
		 */
		userDelete: (
			query: {
				userName: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AdminDeleteUserResponse, any>({
				path: `/umc/user`,
				method: "DELETE",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name UserUpdate
		 * @request PUT:/umc/user
		 */
		userUpdate: (data: UpdateUser, params: RequestParams = {}) =>
			this.request<AmazonWebServiceResponse[], any>({
				path: `/umc/user`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name UserReinviteUpdate
		 * @request PUT:/umc/user/reinvite
		 */
		userReinviteUpdate: (
			query: {
				userName: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AdminCreateUserResponse, any>({
				path: `/umc/user/reinvite`,
				method: "PUT",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name UserEnableUpdate
		 * @request PUT:/umc/user/enable
		 */
		userEnableUpdate: (
			query: {
				userName: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AdminEnableUserResponse, any>({
				path: `/umc/user/enable`,
				method: "PUT",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name UserDisableUpdate
		 * @request PUT:/umc/user/disable
		 */
		userDisableUpdate: (
			query: {
				userName: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AdminDisableUserResponse, any>({
				path: `/umc/user/disable`,
				method: "PUT",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name AccountsList
		 * @request GET:/umc/accounts
		 */
		accountsList: (params: RequestParams = {}) =>
			this.request<Account[], any>({
				path: `/umc/accounts`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name AccountsCreate
		 * @request POST:/umc/accounts
		 */
		accountsCreate: (data: NewAccountRequest, params: RequestParams = {}) =>
			this.request<Account, any>({
				path: `/umc/accounts`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name AccountsDelete
		 * @request DELETE:/umc/accounts
		 */
		accountsDelete: (
			query: {
				/** @format uuid */
				AccountId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<AccountDeleteResponse, any>({
				path: `/umc/accounts`,
				method: "DELETE",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name GetAccountById
		 * @request GET:/umc/account
		 */
		getAccountById: (
			query: {
				/** @format uuid */
				AccountId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<Account, any>({
				path: `/umc/account`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags UmcLambda, Only lambda
		 * @name GetAllUserEmails
		 * @request GET:/umc/users/usermail
		 */
		getAllUserEmails: (
			query: {
				/** @format uuid */
				AccountId: string;
			},
			params: RequestParams = {},
		) =>
			this.request<string[], any>({
				path: `/umc/users/usermail`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),
	};
}
